/**
 * Bundy Bundle Dual-Product Customizer
 * =====================================
 * Handles the dual-engraving flow for the Bundy Bundle product.
 * This is completely separate from the standard customizer and
 * does NOT interfere with any other product's engraving.
 *
 * Products: Bottle (1L or 4L) + Drink Cooler
 * Engraving: Front only for each product
 */

$(document).ready(function () {
  // Only run on Bundy Bundle product page
  if (!$(".popup_bundy_customizer")[0]) return;

  // State management for both products
  var bundyState = {
    activeTab: "bottle", // 'bottle' or 'cooler'
    bottle: {
      text: "",
      font: "Roboto",
      logoUrl: "",
      logoName: "",
      type: "" // 'text', 'logo', or ''
    },
    cooler: {
      text: "",
      font: "Roboto",
      logoUrl: "",
      logoName: "",
      type: "" // 'text', 'logo', or ''
    }
  };
  var FONT_CLASSES = "font-Roboto font-Manderley font-Crosterian font-Whiphand font-Socialist";

  // ==========================================
  // Engravable area — drives real logo/text placement, ported from the DTC
  // customizer's area-driven system (see dtc-area-personalization skill) so
  // desktop, mobile and the confirm-popup thumbnail always agree on where
  // the design lands, instead of the old independent per-breakpoint top%
  // rules below (kept as the legacy fallback if AREA_DRIVEN is flipped off).
  // Ratios are fractions of each product's own rendered main-image box,
  // computed fresh every time — never cached.
  // ==========================================
  var AREA_RATIOS = {
    // Starting placeholders converted from the legacy top%/centered values
    // still in bundy_bundle_customizer.css — not yet visually calibrated
    // (see dtc-area-personalization skill, "Procedure: adding a new size").
    // Cooler uses one shared image regardless of bottle size (confirmed via
    // the product's variant metafields — both variants point at the same
    // back_image), so it only needs a single entry.
    bottle_1l: { w: 0.16, h: 0.22, t: 0.355 },
    bottle_4l: { w: 0.20, h: 0.28, t: 0.47 },
    cooler: { w: 0.30, h: 0.32, t: 0.23 }
  };

  // Single on/off switch — flip to false to fall back to the legacy per-size
  // top% CSS below without deleting it, same rollback story as the DTC
  // customizer's AREA_DRIVEN_SIZES per-size gate.
  var AREA_DRIVEN = true;

  // Laser height convention: a design/logo should never be taller than
  // 1.15x its own width, independent of how tall the area box is.
  var MAX_HEIGHT_RATIO = 1.15;

  function currentBottleSizeTag() {
    return $(".bundy_bottle_preview").hasClass("bundy_size_1l") ? "1l" : "4l";
  }

  function currentAreaRatios(product) {
    return product === "bottle" ? AREA_RATIOS["bottle_" + currentBottleSizeTag()] : AREA_RATIOS.cooler;
  }

  // Pure function of "whatever image is rendered right now" — no cached
  // state. Works identically for the live bottle/cooler previews and for
  // the confirm-popup clone. Uses offset geometry, not
  // getBoundingClientRect(), so it stays correct under the clone's
  // transform:scale() (see dtc-area-personalization skill gotcha).
  function getAreaBox(product, $preview, $img) {
    var r = currentAreaRatios(product);
    if (!$img.length || !r) return null;
    var img = $img[0];
    var iw = img.offsetWidth, ih = img.offsetHeight;
    if (!iw || !ih) return null;
    var offsetLeft = 0, offsetTop = 0, node = img, guard = 0;
    while (node && node !== $preview[0] && guard++ < 20) {
      offsetLeft += node.offsetLeft;
      offsetTop += node.offsetTop;
      node = node.offsetParent;
    }
    var w = iw * r.w, h = ih * r.h;
    var left = offsetLeft + (iw - w) / 2;
    var top = offsetTop + ih * r.t;
    return { left: left, top: top, width: w, height: h, centerX: left + w / 2, bottom: top + h };
  }

  // Debug boundary — a boolean gate kept in code (not a theme setting),
  // toggled by editing this line + committing. Shows a dashed box around
  // the current AREA_RATIOS box for live calibration. Flip to false before
  // anything goes to staging or main.
  var SHOW_DEBUG_AREA = false;

  function positionBoundaryFor(product, $preview, $img, $box) {
    if (!SHOW_DEBUG_AREA) { $box.hide(); return; }
    var area = getAreaBox(product, $preview, $img);
    if (!$box.length || !area) { $box.hide(); return; }
    $box.css({ display: "block", width: area.width + "px", height: area.height + "px", left: area.left + "px", top: area.top + "px" });
  }

  // Sets each prop with priority "important" so it reliably wins regardless
  // of selector specificity in the legacy CSS below.
  function setImportant($el, props) {
    $el.each(function () {
      for (var prop in props) {
        this.style.setProperty(prop, props[prop], "important");
      }
    });
  }

  // Places the actual logo/text against the area box. Bundy's state is
  // mutually exclusive per product (text OR logo, never both), but case
  // detection reads the overlays' actual .hide class state rather than
  // bundyState, same as the DTC implementation — bundyState only gets
  // written on Preview/Review, but the overlay itself becomes visible as
  // soon as the customer picks a font/logo live.
  function positionPersonalizationFor(product, $preview, $img) {
    if (!AREA_DRIVEN) return;
    var area = getAreaBox(product, $preview, $img);
    if (!area) return;
    var $textOverlay = $preview.find(".bundy_text_overlay");
    var $textEl = $preview.find(".bundy_textup");
    var $logoOverlay = $preview.find(".bundy_logo_overlay");
    var $logoImg = $preview.find(".bundy_logo_img");
    var hasText = $textOverlay.length && !$textOverlay.hasClass("hide");
    var hasLogo = $logoOverlay.length && !$logoOverlay.hasClass("hide");
    var type = hasText && hasLogo ? "both" : hasText ? "text" : hasLogo ? "logo" : "";

    if (type === "logo") {
      // Solo diseño: centered in the area, contained within it (aspect ratio
      // preserved), height additionally capped at MAX_HEIGHT_RATIO x width.
      var logoMaxH = Math.min(area.height, area.width * MAX_HEIGHT_RATIO);
      setImportant($logoOverlay, { left: area.centerX + "px", top: (area.top + area.height / 2) + "px", transform: "translate(-50%, -50%)" });
      setImportant($logoImg, { "max-width": area.width + "px", "max-height": logoMaxH + "px" });
    } else if (type === "text") {
      // Solo texto: anchored to the top of the area, width capped to the
      // area's width.
      var soloTextH = $textEl.length ? $textEl[0].offsetHeight : 0;
      setImportant($textOverlay, { left: area.centerX + "px", top: (area.top + soloTextH / 2) + "px", transform: "translate(-50%, -50%)", "max-width": area.width + "px", overflow: "hidden" });
    } else if (type === "both") {
      // Not reachable today (Bundy's state is mutually exclusive per
      // product) — kept for structural parity with the DTC implementation
      // in case that ever changes.
      var textH = $textEl.length ? $textEl[0].offsetHeight : 0;
      var textTop = area.top;
      setImportant($textOverlay, { left: area.centerX + "px", top: (textTop + textH / 2) + "px", transform: "translate(-50%, -50%)", "max-width": area.width + "px", overflow: "hidden" });
      var remaining = area.bottom - (textTop + textH);
      var pad = remaining * 0.12;
      var logoH = Math.min(Math.max(remaining - pad * 2, 0), area.width * MAX_HEIGHT_RATIO);
      var logoCenterY = textTop + textH + pad + logoH / 2;
      setImportant($logoOverlay, { left: area.centerX + "px", top: logoCenterY + "px", transform: "translate(-50%, -50%)" });
      setImportant($logoImg, { "max-width": area.width + "px", "max-height": logoH + "px" });
    }
  }

  function positionBoundary() {
    [["bottle", ".bundy_bottle_preview", ".bundy_bottle_main_image"], ["cooler", ".bundy_cooler_preview", ".bundy_cooler_main_image"]].forEach(function (row) {
      var product = row[0];
      var $preview = $(row[1]);
      var $img = $preview.find(row[2]);
      positionBoundaryFor(product, $preview, $img, $preview.find(".bundy_boundary"));
      positionPersonalizationFor(product, $preview, $img);
    });
  }

  // Call after any content change (text typed, logo picked/cleared, font
  // changed) on the currently active tab — the area itself doesn't move,
  // but which case applies and the text's own rendered width can.
  function refreshActivePersonalization() {
    var product = bundyState.activeTab;
    var selector = product === "bottle" ? ".bundy_bottle_preview" : ".bundy_cooler_preview";
    var imgClass = product === "bottle" ? ".bundy_bottle_main_image" : ".bundy_cooler_main_image";
    var $preview = $(selector);
    positionPersonalizationFor(product, $preview, $preview.find(imgClass));
  }

  // Auto-recompute whenever an observed image's rendered size actually
  // changes — variant size swap, breakpoint shifts, window resize. (Bundy's
  // two previews stay visible the whole time, so unlike DTC's front/back
  // toggle this won't fire on tab switches — those are handled with an
  // explicit positionBoundary() call instead.)
  var boundaryResizeObserver = ("ResizeObserver" in window) ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var $img = $(entry.target);
      var $preview = $img.closest(".bundy_product_preview");
      var product = $preview.hasClass("bundy_bottle_preview") ? "bottle" : "cooler";
      positionBoundaryFor(product, $preview, $img, $preview.find(".bundy_boundary"));
      positionPersonalizationFor(product, $preview, $img);
    });
  }) : null;

  function observeBoundaryImage($img) {
    if (boundaryResizeObserver && $img.length) { boundaryResizeObserver.observe($img[0]); }
  }

  observeBoundaryImage($(".bundy_bottle_main_image"));
  observeBoundaryImage($(".bundy_cooler_main_image"));

  // Fallback for browsers without ResizeObserver / edge cases it can't catch.
  $(window).on("resize", positionBoundary);

  // ==========================================
  // OPEN CUSTOMIZER
  // ==========================================
  $(document).on("click", ".customise_button", function () {
    // Only intercept for Bundy Bundle
    if (!$(".popup_bundy_customizer")[0]) return;

    // Hide the standard customizer if it exists
    $(".popup_pd_customizer").removeClass("active");

    // Reset state
    bundyState.bottle = { text: "", font: "Roboto", logoUrl: "", logoName: "", type: "" };
    bundyState.cooler = { text: "", font: "Roboto", logoUrl: "", logoName: "", type: "" };
    bundyState.activeTab = "bottle";

    // Reset UI
    resetBundyUI();

    // Update variant images based on current selection
    updateBundyVariantImages();

    // Apply texture to text overlays on open
    var selectedOption = $(".bundy_size_select option:selected");
    var variantId = selectedOption.val();
    var variantData = $(".bundy_variant_data[data-variant-id='" + variantId + "']");
    if (variantData.length) {
      var textureUrl = variantData.attr("data-texture");
      if (textureUrl) {
        $(".bundy_textup").css("background-image", 'url("' + textureUrl + '")');
      }
    }

    // Show the Bundy customizer
    $("body").addClass("bundy_customizer_active");
    $(".popup_bundy_customizer").addClass("active");
    setTimeout(positionBoundary, 50);
  });

  // ==========================================
  // CLOSE CUSTOMIZER
  // ==========================================
  $(document).on("click", ".bundy_close_btn", function () {
    $(".popup_bundy_customizer").removeClass("active");
    $("body").removeClass("bundy_customizer_active");
  });

  // ==========================================
  // TAB SWITCHING
  // ==========================================
  $(document).on("click", ".bundy_tab_bottle", function () {
    saveCurrentTabState();
    bundyState.activeTab = "bottle";
    $(".bundy_tab").removeClass("active");
    $(this).addClass("active");
    $(".bundy_bottle_preview").addClass("active");
    $(".bundy_cooler_preview").removeClass("active");
    restoreTabState("bottle");
    goToSelectionMenu();
    positionBoundary();
  });

  $(document).on("click", ".bundy_tab_cooler", function () {
    saveCurrentTabState();
    bundyState.activeTab = "cooler";
    $(".bundy_tab").removeClass("active");
    $(this).addClass("active");
    $(".bundy_cooler_preview").addClass("active");
    $(".bundy_bottle_preview").removeClass("active");
    restoreTabState("cooler");
    goToSelectionMenu();
    positionBoundary();
  });

  // ==========================================
  // VARIANT SIZE SELECTOR
  // ==========================================
  $(document).on("change", ".bundy_size_select", function () {
    updateBundyVariantImages();
    setTimeout(positionBoundary, 50);
    // Also update the main product page variant selector
    var selectedOption = $(this).find("option:selected");
    var variantTitle = selectedOption.text().trim();
    var mainSelect = $("#ProductSelect-option-1");
    if (mainSelect.length) {
      mainSelect.val(variantTitle);
      mainSelect[0].dispatchEvent(new Event("change", { bubbles: true }));
    }
  });

  // ==========================================
  // TEXT OPTION
  // ==========================================
  $(document).on("click", ".bundy_text_option", function () {
    $(".bundy_selection_menu").addClass("hide");
    $(".bundy_text_section").removeClass("hide");
    $(".bundy_logo_section").addClass("hide");

    // Restore any existing text for this tab
    var state = bundyState[bundyState.activeTab];
    if (state.type === "text" && state.text) {
      $(".bundy_text_input").val(state.text);
      var fontClass = "font-" + state.font;
      $(".bundy_text_input").removeClass(FONT_CLASSES).addClass(fontClass);
      $(".bundy_font_item").removeClass("active");
      $(".bundy_font_item[data-font='" + state.font + "']").addClass("active");
      $(".bundy_preview_text").removeAttr("disabled");
    } else {
      $(".bundy_text_input").val("");
      $(".bundy_text_input").removeClass(FONT_CLASSES).addClass("font-Roboto");
      $(".bundy_font_item").removeClass("active");
      $(".bundy_font_item[data-font='Roboto']").addClass("active");
      $(".bundy_preview_text").attr("disabled", "disabled");
    }
  });

  // Text input handling
  var RE_EMOJI = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
  var RE_SPECIAL = /[^a-zA-Z0-9\s]/g;

  $(document).on("keyup keydown change paste input", ".bundy_text_input", function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
      return false;
    }

    var $elem = $(this);
    var content = $elem.val();

    // Remove emojis and special characters
    if (RE_EMOJI.test(content) || RE_SPECIAL.test(content)) {
      content = content.replace(RE_EMOJI, "").replace(RE_SPECIAL, "");
      $elem.val(content);
    }

    var valLength = content.length;
    var maxSize = parseInt($elem.attr("data-size")) || 10;

    if (valLength > maxSize) {
      $(".bundy_char_warning").removeClass("hide");
      $(".bundy_preview_text").attr("disabled", "disabled");
    } else {
      $(".bundy_char_warning").addClass("hide");
      if (valLength > 0) {
        $(".bundy_preview_text").removeAttr("disabled");
      } else {
        $(".bundy_preview_text").attr("disabled", "disabled");
      }
    }

    // Update preview on active product
    updateActivePreviewText(content);
    refreshActivePersonalization();
  });

  // Font selection
  $(document).on("click", ".bundy_font_item", function () {
    $(".bundy_font_item").removeClass("active");
    $(this).addClass("active");
    var font = $(this).attr("data-font");
    $(".bundy_text_input").removeClass(FONT_CLASSES).addClass("font-" + font);

    // Update preview font
    var activePreview = bundyState.activeTab === "bottle" ? ".bundy_bottle_preview" : ".bundy_cooler_preview";
    $(activePreview + " .bundy_textup").removeClass(FONT_CLASSES).addClass("font-" + font);
    refreshActivePersonalization();
  });

  // Text preview/review button
  $(document).on("click", ".bundy_preview_text", function () {
    var text = $(".bundy_text_input").val().trim();
    var font = $(".bundy_font_item.active").attr("data-font");

    // Save to state
    bundyState[bundyState.activeTab].text = text;
    bundyState[bundyState.activeTab].font = font;
    bundyState[bundyState.activeTab].logoUrl = "";
    bundyState[bundyState.activeTab].logoName = "";
    bundyState[bundyState.activeTab].type = "text";

    // Update preview
    updateActivePreviewText(text);
    var activePreview = bundyState.activeTab === "bottle" ? ".bundy_bottle_preview" : ".bundy_cooler_preview";
    $(activePreview + " .bundy_textup").removeClass(FONT_CLASSES).addClass("font-" + font);
    refreshActivePersonalization();

    // Show add-to-cart section if both products have customization OR show prompt
    checkAndShowReview();
  });

  // Clear text
  $(document).on("click", ".bundy_clear_text", function () {
    $(".bundy_text_input").val("");
    $(".bundy_preview_text").attr("disabled", "disabled");
    bundyState[bundyState.activeTab].text = "";
    bundyState[bundyState.activeTab].type = "";

    var activePreview = bundyState.activeTab === "bottle" ? ".bundy_bottle_preview" : ".bundy_cooler_preview";
    $(activePreview + " .bundy_text_overlay").addClass("hide");
    $(activePreview + " .bundy_textup").html("");
    $(activePreview + " .bundy_logo_overlay").addClass("hide");
  });

  // ==========================================
  // LOGO OPTION
  // ==========================================
  $(document).on("click", ".bundy_logo_option", function () {
    $(".bundy_selection_menu").addClass("hide");
    $(".bundy_logo_section").removeClass("hide");
    $(".bundy_text_section").addClass("hide");
  });

  // Logo search
  $(document).on("keyup", ".bundy_search_input", function () {
    var query = $(this).val().toLowerCase();
    $(".bundy_logo_item").each(function () {
      var name = $(this).attr("data-search") || "";
      if (name.indexOf(query) >= 0 || query === "") {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });

  // Logo selection
  $(document).on("click", ".bundy_logo_image", function () {
    $(".bundy_logo_image").removeClass("active");
    $(this).addClass("active");
    $(".bundy_preview_logo").removeAttr("disabled");

    var logoSrc = $(this).attr("data-texture");
    var logoName = $(this).siblings(".bundy_logo_name").text().trim();

    // Update preview on active product
    var activePreview = bundyState.activeTab === "bottle" ? ".bundy_bottle_preview" : ".bundy_cooler_preview";
    $(activePreview + " .bundy_logo_overlay").removeClass("hide");
    $(activePreview + " .bundy_logo_img").attr("src", logoSrc);
    $(activePreview + " .bundy_text_overlay").addClass("hide");
    refreshActivePersonalization();
  });

  // Logo preview/review button
  $(document).on("click", ".bundy_preview_logo", function () {
    var activeLogo = $(".bundy_logo_image.active");
    if (!activeLogo.length) return;

    var logoSrc = activeLogo.attr("data-texture");
    var logoName = activeLogo.siblings(".bundy_logo_name").text().trim();

    // Save to state
    bundyState[bundyState.activeTab].logoUrl = logoSrc;
    bundyState[bundyState.activeTab].logoName = logoName;
    bundyState[bundyState.activeTab].text = "";
    bundyState[bundyState.activeTab].type = "logo";
    refreshActivePersonalization();

    checkAndShowReview();
  });

  // Clear logo
  $(document).on("click", ".bundy_clear_logo", function () {
    $(".bundy_logo_image").removeClass("active");
    $(".bundy_preview_logo").attr("disabled", "disabled");
    bundyState[bundyState.activeTab].logoUrl = "";
    bundyState[bundyState.activeTab].logoName = "";
    bundyState[bundyState.activeTab].type = "";

    var activePreview = bundyState.activeTab === "bottle" ? ".bundy_bottle_preview" : ".bundy_cooler_preview";
    $(activePreview + " .bundy_logo_overlay").addClass("hide");
    $(activePreview + " .bundy_logo_img").attr("src", "");
  });

  // Back buttons
  $(document).on("click", ".bundy_back_btn", function () {
    goToSelectionMenu();
  });

  // ==========================================
  // REVIEW & ADD TO CART
  // ==========================================
  function checkAndShowReview() {
    var bottleHas = bundyState.bottle.type !== "";
    var coolerHas = bundyState.cooler.type !== "";

    // Update review summary
    updateReviewSummary();

    if (bottleHas && coolerHas) {
      // Both products customized - go straight to add to cart
      showAddToCart();
    } else if (bottleHas || coolerHas) {
      // Only one product done — stay on the selection menu so the customer
      // can add the other one, or hit Review to proceed with just this one
      goToSelectionMenu();
    }
  }

  function showAddToCart() {
    $(".bundy_addtocart_section").removeClass("hide");
    $(".bundy_customize_section").addClass("hide");
    $(".bundy_tabs").addClass("hide");
    $(".bundy_menu_review_btn").addClass("hide");

    // Show both previews
    $(".bundy_bottle_preview").addClass("active");
    $(".bundy_cooler_preview").addClass("active");
  }

  // Selection menu Review button — lets the customer proceed with just one
  // product personalised instead of requiring both
  $(document).on("click", ".bundy_menu_review_btn", function () {
    updateReviewSummary();
    showAddToCart();
  });

  function updateReviewSummary() {
    var unitPrice = parseFloat($(".bundy_left_previews").data("price")) || 0;
    var cur = $(".bundy_left_previews").data("cur") || "$";
    var priceStr = cur + unitPrice.toFixed(2);

    ["bottle", "cooler"].forEach(function (product) {
      var s = bundyState[product];
      var $slot = $('.bundy_review_slot[data-product="' + product + '"]');

      if (s.type === "logo" && s.logoUrl) {
        $slot.addClass("active");
        $slot.find(".bundy_slot_label").text("Design");
        $slot.find(".bundy_slot_value")
          .removeClass(FONT_CLASSES)
          .html('<img src="' + s.logoUrl + '" alt="' + s.logoName + '">');
        $slot.find(".bundy_slot_price").text(priceStr);
      } else if (s.type === "text" && s.text) {
        $slot.addClass("active");
        $slot.find(".bundy_slot_label").text("Text");
        $slot.find(".bundy_slot_value")
          .removeClass(FONT_CLASSES)
          .addClass("font-" + s.font)
          .text(s.text);
        $slot.find(".bundy_slot_price").text(priceStr);
      } else {
        $slot.removeClass("active");
        $slot.find(".bundy_slot_value").removeClass(FONT_CLASSES).empty();
      }
    });
  }

  // Navigate from the review screen back to a given product's customize tab
  function navFromReview(product) {
    $(".bundy_addtocart_section").addClass("hide");
    $(".bundy_customize_section").removeClass("hide");
    $(".bundy_tabs").removeClass("hide");
    $(".bundy_tab_" + product).trigger("click");
  }

  $(document).on("click", ".bundy_review_back_nav", function () {
    navFromReview(bundyState.activeTab);
  });

  $(document).on("click", ".bundy_slot_empty, .bundy_slot_edit", function (e) {
    e.stopPropagation();
    var product = $(this).closest(".bundy_review_slot").data("product");
    navFromReview(product);
  });

  // Quantity controls
  $(document).on("click", ".bundy_qty_add", function () {
    var input = $(".bundy_qty_input");
    input.val(parseInt(input.val()) + 1);
  });

  $(document).on("click", ".bundy_qty_sub", function () {
    var input = $(".bundy_qty_input");
    if (parseInt(input.val()) > 1) {
      input.val(parseInt(input.val()) - 1);
    }
  });

  // Add to Cart button
  $(document).on("click", ".bundy_add_to_cart", function () {
    // Show the popup first so .bundy_confirm_preview_thumb is actually laid
    // out — its CSS height varies by breakpoint, so we need the real
    // rendered height before measuring below.
    $(".bundy_confirm_popup").removeClass("hide");
    $(".bundy_addtocart_section").addClass("hide");

    // Build preview thumbnails — clone the live previews, scale down inside
    // the fixed thumb container (mirrors the DTC customizer's confirm step)
    [["bottle", ".bundy_bottle_preview"], ["cooler", ".bundy_cooler_preview"]].forEach(function (pair) {
      var product = pair[0], selector = pair[1];
      var $wrap = $('.bundy_confirm_preview_wrap[data-product="' + product + '"]');
      var $thumb = $wrap.find(".bundy_confirm_preview_thumb");
      var $source = $(selector);

      // Hide this column if that product wasn't personalised
      if (bundyState[product].type === "" || !$source.length) {
        $wrap.addClass("hide");
        return;
      }
      $wrap.removeClass("hide");

      var $clone = $source.clone();
      $clone.find(".bundy_label").remove();
      var thumbH = $thumb.outerHeight() || 260;
      var srcH = $source.outerHeight() || 280;
      var scale = thumbH / srcH;
      var srcW = $source.outerWidth() || 200;
      $clone.css({
        position: "absolute",
        top: 0,
        left: "50%",
        transform: "scale(" + scale + ") translateX(-50%)",
        "transform-origin": "top left",
        width: srcW + "px",
        "pointer-events": "none"
      });
      $thumb.css({ position: "relative", overflow: "hidden", height: thumbH + "px" }).html("").append($clone);

      // Recompute the boundary and personalization against the clone's own
      // (now-scaled) image rect — its internal geometry differs from the
      // live source (e.g. the confirm-thumb strips the card padding/border),
      // so cloned inline styles can't just be reused as-is. See
      // dtc-area-personalization skill's transform:scale() gotcha.
      var imgClass = product === "bottle" ? ".bundy_bottle_main_image" : ".bundy_cooler_main_image";
      positionBoundaryFor(product, $clone, $clone.find(imgClass), $clone.find(".bundy_boundary"));
      positionPersonalizationFor(product, $clone, $clone.find(imgClass));
    });
  });

  // Confirmation checkbox
  $(document).on("click", ".bundy_chkbox.none", function () {
    $(this).addClass("active").removeClass("none");
    $(".bundy_accept_btn").removeAttr("disabled").addClass("active");
  });

  $(document).on("click", ".bundy_chkbox.active", function () {
    $(this).addClass("none").removeClass("active");
    $(".bundy_accept_btn").attr("disabled", "disabled").removeClass("active");
  });

  // Cancel confirmation
  $(document).on("click", ".bundy_cancel_btn", function () {
    $(".bundy_confirm_popup").addClass("hide");
    $(".bundy_addtocart_section").removeClass("hide");
  });

  // ACCEPT - Submit to cart
  $(document).on("click", ".bundy_accept_btn.active", function (e) {
    e.preventDefault();

    var $btn = $(this);
    $btn.html("Loading....");

    var leftPreviews = $(".bundy_left_previews");
    var pricewithoutcurrency = leftPreviews.attr("data-price");
    var pricemoney = leftPreviews.attr("data-moncurreny");
    var currencyf = leftPreviews.attr("data-cur");
    var product_title = leftPreviews.attr("data-title");
    var qty = parseInt($(".bundy_qty_input").val()) || 1;

    // Get variant ID from the size selector
    var var_id = parseInt($(".bundy_size_select").val());
    var customized_pd = parseInt($(".bundy_data").attr("data-customized-product-id"));

    // Calculate total customization charges
    var customQty = 0;
    if (bundyState.bottle.type !== "") customQty++;
    if (bundyState.cooler.type !== "") customQty++;

    var items = [];

    // Main product
    items.push({
      id: var_id,
      quantity: qty,
      properties: {
        _customised_product: "yes"
      }
    });

    // Customization surcharge with both products' details
    var properties = {
      "_Customised Product": "yes",
      "BUNDLE TYPE": customQty === 2 ? "Dual Engraving" : "Single Engraving"
    };

    addEngravingProperties(properties, "BOTTLE", bundyState.bottle, product_title);
    addEngravingProperties(properties, "COOLER", bundyState.cooler, product_title);

    items.push({
      id: customized_pd,
      quantity: customQty,
      properties: properties
    });

    setTimeout(function () {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: { items: items },
        dataType: "json",
        success: function (response) {
          if (window.openCartDrawer) window.openCartDrawer();

          // Close and reset
          $(".popup_bundy_customizer").removeClass("active");
          $("body").removeClass("bundy_customizer_active");
          $btn.html("ACCEPT");
          resetBundyUI();
        },
        error: function () {
          console.error("Error adding Bundy Bundle to cart");
          $btn.html("ACCEPT");
          alert("There was an error adding to cart. Please try again.");
        }
      });
    }, 1000);
  });

  // ==========================================
  // HELPER FUNCTIONS
  // ==========================================
  function addEngravingProperties(properties, prefix, item, title) {
    if (item.type === "text") {
      properties[prefix + " ENGRAVING"] = title;
      properties[prefix + " NAME"] = item.text;
      properties[prefix + " FONT"] = item.font;
    } else if (item.type === "logo") {
      properties[prefix + " ENGRAVING"] = title;
      properties[prefix + " IMAGE"] = item.logoUrl;
      properties[prefix + " GALLERY IMAGE NAME"] = item.logoName;
    }
  }

  function resetBundyUI() {
    // Reset tabs
    $(".bundy_tab").removeClass("active");
    $(".bundy_tab_bottle").addClass("active");
    $(".bundy_bottle_preview").addClass("active");
    $(".bundy_cooler_preview").removeClass("active");

    // Reset sections
    $(".bundy_selection_menu").removeClass("hide");
    $(".bundy_text_section").addClass("hide");
    $(".bundy_logo_section").addClass("hide");
    $(".bundy_addtocart_section").addClass("hide");
    $(".bundy_confirm_popup").addClass("hide");
    $(".bundy_customize_section").removeClass("hide");
    $(".bundy_tabs").removeClass("hide");
    $(".bundy_menu_review_btn").addClass("hide");

    // Reset previews
    $(".bundy_text_overlay").addClass("hide");
    $(".bundy_textup").html("");
    $(".bundy_logo_overlay").addClass("hide");
    $(".bundy_logo_img").attr("src", "");

    // Reset inputs
    $(".bundy_text_input").val("");
    $(".bundy_font_item").removeClass("active");
    $(".bundy_font_item[data-font='Roboto']").addClass("active");
    $(".bundy_logo_image").removeClass("active");
    $(".bundy_search_input").val("");
    $(".bundy_logo_item").show();

    // Reset confirmation
    $(".bundy_chkbox").addClass("none").removeClass("active");
    $(".bundy_accept_btn").attr("disabled", "disabled").removeClass("active");
    $(".bundy_accept_btn").html("ACCEPT");

    // Reset qty
    $(".bundy_qty_input").val(1);
  }

  function goToSelectionMenu() {
    $(".bundy_selection_menu").removeClass("hide");
    $(".bundy_text_section").addClass("hide");
    $(".bundy_logo_section").addClass("hide");
    $(".bundy_logo_image").removeClass("active");
    $(".bundy_search_input").val("");
    $(".bundy_logo_item").show();

    // Show the Review button if either product already has content
    var anyContent = bundyState.bottle.type !== "" || bundyState.cooler.type !== "";
    if (anyContent) {
      $(".bundy_menu_review_btn").removeClass("hide");
    } else {
      $(".bundy_menu_review_btn").addClass("hide");
    }
  }

  function saveCurrentTabState() {
    // Save any unsaved text input
    if (!$(".bundy_text_section").hasClass("hide")) {
      var text = $(".bundy_text_input").val().trim();
      var font = $(".bundy_font_item.active").attr("data-font");
      if (text) {
        bundyState[bundyState.activeTab].text = text;
        bundyState[bundyState.activeTab].font = font;
        bundyState[bundyState.activeTab].type = "text";
        bundyState[bundyState.activeTab].logoUrl = "";
        bundyState[bundyState.activeTab].logoName = "";
      }
    }
    // Save any unsaved logo selection
    if (!$(".bundy_logo_section").hasClass("hide")) {
      var activeLogo = $(".bundy_logo_image.active");
      if (activeLogo.length) {
        bundyState[bundyState.activeTab].logoUrl = activeLogo.attr("data-texture");
        bundyState[bundyState.activeTab].logoName = activeLogo.siblings(".bundy_logo_name").text().trim();
        bundyState[bundyState.activeTab].type = "logo";
        bundyState[bundyState.activeTab].text = "";
      }
    }
  }

  function restoreTabState(tab) {
    var state = bundyState[tab];
    // Restore preview
    var preview = tab === "bottle" ? ".bundy_bottle_preview" : ".bundy_cooler_preview";

    if (state.type === "text" && state.text) {
      $(preview + " .bundy_text_overlay").removeClass("hide");
      $(preview + " .bundy_textup").html(state.text);
      $(preview + " .bundy_textup").removeClass(FONT_CLASSES).addClass("font-" + state.font);
      $(preview + " .bundy_logo_overlay").addClass("hide");
    } else if (state.type === "logo" && state.logoUrl) {
      $(preview + " .bundy_logo_overlay").removeClass("hide");
      $(preview + " .bundy_logo_img").attr("src", state.logoUrl);
      $(preview + " .bundy_text_overlay").addClass("hide");
    }
  }

  function updateActivePreviewText(text) {
    var activePreview = bundyState.activeTab === "bottle" ? ".bundy_bottle_preview" : ".bundy_cooler_preview";
    if (text) {
      $(activePreview + " .bundy_text_overlay").removeClass("hide");
      $(activePreview + " .bundy_textup").html(text);
      $(activePreview + " .bundy_logo_overlay").addClass("hide");
    } else {
      $(activePreview + " .bundy_text_overlay").addClass("hide");
      $(activePreview + " .bundy_textup").html("");
    }
  }

  function updateBundyVariantImages() {
    var selectedOption = $(".bundy_size_select option:selected");
    var frontSrc = selectedOption.attr("data-front");
    var backSrc = selectedOption.attr("data-back");

    if (frontSrc) {
      $(".bundy_bottle_main_image").attr("src", frontSrc);
    }
    if (backSrc) {
      $(".bundy_cooler_main_image").attr("src", backSrc);
    }

    // Apply texture to text overlays
    var variantId = selectedOption.val();
    var variantData = $(".bundy_variant_data[data-variant-id='" + variantId + "']");
    if (variantData.length) {
      var textureUrl = variantData.attr("data-texture");
      if (textureUrl) {
        $(".bundy_textup").css("background-image", 'url("' + textureUrl + '")');
      }
    }

    // Add size class to bottle preview for CSS positioning
    var variantText = selectedOption.text().trim().toLowerCase();
    var bottlePreview = $(".bundy_bottle_preview");
    bottlePreview.removeClass("bundy_size_4l bundy_size_1l");
    if (variantText.indexOf("1l") !== -1) {
      bottlePreview.addClass("bundy_size_1l");
    } else {
      bottlePreview.addClass("bundy_size_4l");
    }

    // Update variant name display
    $(".bundy_variant_name").text(selectedOption.text().trim());
  }
});

/* ============================================
 * Bundy Bundle Gallery Image Reorder
 * ============================================
 * Reorders the product gallery images based on
 * the selected bottle size (4L or 1L).
 * Uses a MutationObserver to detect when the
 * slider is rebuilt and reorder accordingly.
 */
(function() {
  // Desired image order per bottle size (match by filename substring)
  var orderMap = {
    '4l': [
      'TAP_x_Bundy_Rum_-_Collection_Page_1b_-_WEBP',
      'Bundle-flatlay-BundabergRum-4L',
      '4L-Bottle-BundabergRum-bundle',
      'Stubby-BundabergRum-4L-bundle',
      'Backpack-lifestyle-BundabergRum-4L-bundle'
    ],
    '1l': [
      'TAP_x_Bundy_Rum_-_Collection_Page_1b_-_WEBP',
      'Bundle-flatlay-BundabergRum-1L',
      '1L-Bottle-BundabergRum-bundle',
      'Stubby-BundabergRum-1L-bundle',
      'Backpack-lifestyle-BundabergRum-1L-bundle'
    ]
  };

  function getSelectedSize() {
    var sel = document.querySelector('#ProductSelect-option-1');
    return sel ? sel.value.toLowerCase() : '';
  }

  function reorderSliderImages() {
    var sizeKey = getSelectedSize();
    var order = orderMap[sizeKey];
    if (!order) return;

    var sliderContent = document.querySelector('.slider-content');
    var sliderThumb = document.querySelector('.slider-thumb');
    if (!sliderContent) return;

    // Only act when slick is initialized
    if (!sliderContent.classList.contains('slick-initialized')) return;

    // Get current slides (non-cloned)
    var contentSlides = Array.from(sliderContent.querySelectorAll('.slick-slide:not(.slick-cloned)'));
    if (contentSlides.length === 0) return;

    // Check if already in correct order
    var alreadyOrdered = true;
    for (var i = 0; i < Math.min(order.length, contentSlides.length); i++) {
      var img = contentSlides[i].querySelector('img');
      if (img && img.src.indexOf(order[i]) === -1) {
        alreadyOrdered = false;
        break;
      }
    }
    if (alreadyOrdered) return;

    // Collect slide HTML
    var slideHtmlArr = [];
    contentSlides.forEach(function(slide) {
      var inner = slide.querySelector('.inner_mainmedia');
      if (inner) {
        slideHtmlArr.push({ html: inner.innerHTML, el: inner });
      }
    });

    // Sort by the order map
    var sorted = [];
    var remaining = slideHtmlArr.slice();
    order.forEach(function(name) {
      for (var i = 0; i < remaining.length; i++) {
        if (remaining[i].html.indexOf(name) !== -1) {
          sorted.push(remaining[i]);
          remaining.splice(i, 1);
          break;
        }
      }
    });
    sorted = sorted.concat(remaining);

    // Rebuild HTML
    var newHtml = '';
    sorted.forEach(function(item) {
      newHtml += '<div class="inner_mainmedia">' + item.html + '</div>';
    });

    // Rebuild sliders
    try {
      $('.slider-content').slick('unslick');
      $('.slider-thumb').slick('unslick');
    } catch(e) {}

    sliderContent.innerHTML = newHtml;
    if (sliderThumb) sliderThumb.innerHTML = newHtml;

    try {
      $('.slider-content').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        infinite: false,
        speed: 1000,
        asNavFor: '.slider-thumb'
      });
      $('.slider-thumb').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.slider-content',
        dots: false,
        arrows: true,
        centerMode: false,
        focusOnSelect: true
      });
      $('.slider-thumb')[0].slick.refresh();
    } catch(e) {}
  }

  // Watch for slider initialization/rebuild via MutationObserver
  function setupObserver() {
    var sliderContent = document.querySelector('.slider-content');
    if (!sliderContent) {
      // Retry if slider not yet in DOM
      setTimeout(setupObserver, 500);
      return;
    }

    var observer = new MutationObserver(function(mutations) {
      // Debounce: wait a bit after mutations settle
      clearTimeout(observer._debounce);
      observer._debounce = setTimeout(function() {
        if (sliderContent.classList.contains('slick-initialized')) {
          reorderSliderImages();
        }
      }, 300);
    });

    observer.observe(sliderContent, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    // Also reorder when size dropdown changes
    var sizeSelect = document.querySelector('#ProductSelect-option-1');
    if (sizeSelect) {
      sizeSelect.addEventListener('change', function() {
        // Wait for the slider to be rebuilt by the main script
        setTimeout(reorderSliderImages, 1500);
      });
    }

    // Initial reorder attempt after page scripts run
    setTimeout(reorderSliderImages, 2000);
    setTimeout(reorderSliderImages, 4000);
  }

  // Start observing
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObserver);
  } else {
    setupObserver();
  }
})();

/* ============================================
 * Bundy Bundle "Pick Your Bottle Size" Label
 * ============================================
 * Overrides the "Bottle Size" label text via JS
 * so it works even when the page is served from
 * the CWV Booster cache.
 */
(function() {
  function fixBottleSizeLabel() {
    // Fix the main product label
    var labels = document.querySelectorAll('label[data-option-name="Bottle Size"]');
    labels.forEach(function(label) {
      var span = label.querySelector('.text-sub');
      if (span && label.textContent.indexOf('Pick Your') === -1) {
        label.innerHTML = 'Pick Your Bottle Size: ' + span.outerHTML;
      }
    });

    // Fix the customizer variant_tiles label
    var tiles = document.querySelectorAll('.variant_tiles');
    tiles.forEach(function(tile) {
      if (tile.textContent.trim() === 'Bottle Size') {
        tile.textContent = 'Pick Your Bottle Size';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', fixBottleSizeLabel);
})();
